import PSA from '../../psa';
import Utils from '../../utils/Utils';
import Validator from '../../utils/Validator';
import RequestHolder from '../../utils/RequestHolder';
import ConMgr from '../../ssn/ConMgr';
import TimMgr from '../../ssn/TimMgr';
import DskNfy from '../../ssn/DskNfy';
import WndAcv from '../../gui/misc/WndAcv';
import VieTglBtn from '../../gui/misc/VieTglBtn';
import FloMsgMgr from '../../gui/misc/FloMsgMgr';
import BscMgr from '../../gui/BscMgr';
import MnuMgr from '../../gui/menu/MnuMgr';
import QvwMgr from '../../gui/qvw/QvwMgr';
import FileDropTarget from '../../dnd/FileDropTarget';
import RchTxtMgr from '../rchtxt/RchTxtMgr';
import ItmMgr from '../../gui/ItmMgr';
import ThemeMgr from '../../gui/ThemeMgr';
import { PisaCKEditor } from 'pisa-cke5v2-84';

class RdrRqu {
	constructor(_name, _idw, _rqu, _par) {
		Object.defineProperty(this, 'name', { value: _name, configurable: false, enumerable: true, writable: false});
		Object.defineProperty(this, 'idw', { value: _idw, configurable: false, enumerable: true, writable: false});
		Object.defineProperty(this, 'rqu', { value: _rqu, configurable: false, enumerable: true, writable: false});
		Object.defineProperty(this, 'par', { value: _par, configurable: false, enumerable: true, writable: false});
		Object.freeze(this);
	}
}

export default class CliCbkWdg {

	constructor(properties) {
		const psa = PSA.getInst();
		Utils.bindAll(this, [ "layout", "onReady", "onRender" ]);
		this.focusHistory = [];
		this.ready = false;
		this.objNames = null;
		this.pndCbk = null;
		this.xtrViw = false;
		this.xtvTyp = null;
		this.scrNfo = null;
		this._instance_id = null;
		const parent = rap.getObject(properties.parent);
		this.parent = parent;
		this.element = document.createElement("div");
		this.parent.append(this.element);
		this.parent.addListener("Resize", this.layout);
		this.parent.setData("pisasales.CliCbkWdg.this", this);
		let dkn_off = false;
		const cwd = parent.getData("pisasales.CSTPRP.CWD") || {};
		if ( cwd ) {
			const idw = cwd.idw || '';
			if ( idw ) {
				this.element.id = 'cbkWdg_' + idw;
			}
			psa.setDbgMode(!!cwd.dbgMod);
			psa.setJsFeatures(cwd.jsFeatures || []);
			const xtv = cwd.isXtrViw || false;
			if ( xtv ) {
				this.xtrViw = true;
				this.xtvTyp = cwd.xtvTyp || '';
			} else {
				this.xtrViw = false;
				this.xtvTyp = '';
			}
			dkn_off = !!cwd.dknOff;
			const frc = !!cwd.dbgLog || psa.isDbgMode();
			psa.Log.setLogAct(psa.Log.isLogAct() || frc);
			const lng = cwd.usrLng;
			if ( Validator.isString(lng) ) {
				psa.usrLng = lng;
				moment.locale(lng);
			}
			// set instance ID if available
			const ids = cwd.instance_id;
			if ( Validator.isString(ids) ) {
				this._instance_id = ids;
			}
		}
		const bsc_image = cwd ? (cwd.bscImg || null) : null;
		this.objNames = [];
		this.addObj('conMgr', new ConMgr(this));
		this.addObj('itmMgr', ItmMgr.getInst());
		this.addObj('timMgr', new TimMgr(this));
		this.addObj('dskNfy', new DskNfy(dkn_off));
		this.addObj('floMgr', new FloMsgMgr());
		this.addObj('vieTgl', new VieTglBtn(this));
		this.addObj('bscMgr', psa._bscMgr = new BscMgr(this, bsc_image));
		this.addObj('themeMgr', ThemeMgr.getInstance());
		this.addObj('mnuMgr', psa._mnuMgr = new MnuMgr(psa, this));
		this.addObj('qvwMgr', psa._qvwMgr = new QvwMgr(this));
		rap.on("render", this.onRender);
		this.requestHolder = new RequestHolder(true);
		psa._requestHolder = this.requestHolder;
		this.rrqCount = 0;
		const self = this;
		document.body.addEventListener("blur", self.blrFct = function(evt) {
			self._blur(evt);
		}, true);
		document.body.addEventListener("click", self.clkFct = function(evt) {
			self._click(evt);
		}, true);
		RchTxtMgr.createInstance(this);
		this._vfyCount = 0;
	}
	
	/**
	 * @returns {String} the instance ID or null if not available
	 */
	get instance_id() {
		return this._instance_id;
	}

	destroy() {
		const psa = PSA.getInst();
		if ( this.requestHolder ) {
			this.requestHolder.destroy();
			this.requestHolder = null;
			psa._requestHolder = null;
		}
		this._stopSsnVerification();
		this.ready = false;
		let all = false;
		if ( psa.cliCbkWdg === this ) {
			all = true;
		}
		while ( this.objNames.length > 0 ) {
			const name = this.objNames.pop();
			const obj = this[name];
			obj.destroy();
			delete this[name];
		}
		if ( all ) {
			psa.cliCbkWdg = null;
		}
		if ( this.element && this.element.parentNode ) {
			this.element.parentNode.removeChild(this.element);
		}
	}

	onReady() {
		const psa = PSA.getInst();
		this.ready = true;
		psa.cliCbkWdg = this;
		this.layout();
		this._sndTmz();
		this._sndStg();
		if ( this.pndCbk ) {
			for ( let i = 0; i < this.pndCbk.length; ++i ) {
				this.callBack(this.pndCbk[i]);
			}
			delete this.pndCbk;
		}
		const self = this;
		if ( this.isXtrViw() ) {
			window.onresize = function() {
				self._onWndPos();
			};
		}
		this.nfySrv(null, 'cbwReady', { ready: true }, false);
	}

	onRender() {
		if ( this.element ) {
			rap.off("render", this.onRender);
			this.onReady();
		}
	}

	addObj(name, obj) {
		if ( !name || name.length <= 0 || !obj || !obj.destroy ) {
			throw new Error("Invalid atguments: ('" + name + "', " + obj + ")");
		}
		this[name] = obj;
		this.objNames.push(name);
	}

	layout() {
		if ( this.ready ) {
			const area = this.parent.getClientArea();
			this.element.style.left = area[0] + "px";
			this.element.style.top = area[1] + "px";
			this.element.style.width = area[2] + "px";
			this.element.style.height = area[3] + "px";
		}
	}

	callSrv(idw, code, par) {
		if ( this.ready ) {
			const tms = Date.now();
			const param = {};
			param.tms = tms;
			if ( idw ) {
				param.idw = idw;
			}
			param.par = par;
			rap.getRemoteObject(this).call(code, param);
		}
	}

	nfySrv(idw, code, par, bsc) {
		if ( this.ready ) {
			let nfc = 'PSA_NFY_SRV';
			if ( typeof bsc === 'boolean' ) {
				if ( bsc ) {
					this.setBscRqu();
				} else {
					this.conMgr.setIgnRqu();
					nfc = 'PSA_NFY_NBS';
				}
			} else if ( bsc === null ) {
				nfc = 'PSA_NFY_NBS';
			}
			const tms = Date.now();
			const param = {};
			if ( idw ) {
				param.idw = idw;
			}
			param.cod = code;
			param.par = par;
			param.tms = tms;
			rap.getRemoteObject(this).notify(nfc, param);
		}
	}

	nfyGlb(code, par, bsc) {
		this.nfySrv(null, code, par, bsc);
	}

	nfyErr(opr, err, idw) {
		if ( this.ready ) {
			const tms = Date.now();
			const param = {};
			param.opr = opr;
			param.tms = tms;
			if ( err ) {
				if ( err.stack ) {
					param.stk = '' + err.stack;
				}
				param.err = '' + err;
			}
			if ( idw ) {
				param.idw = idw;
			}
			console.log('CliCbkWdg ERROR: ' + err + ' (' + tms + ')');
			rap.getRemoteObject(this).notify("PSA_NFY_ERR", param);
		}
	}

	sndMouEvt(code, evt, bsc) {
		if ( this.ready && evt.widget ) {
			const idw = evt.widget.getData("pisasales.CSTPRP.IDW");
			if ( idw ) {
				const par = {};
				par["x"] = evt.x;
				par["y"] = evt.y;
				par["btn"] = evt.button;
				par["typ"] = evt.type;
				this.nfySrv(idw, code, par, bsc);
			}
		}
	}

	logTxt(par) {
		PSA.getInst().Log.getConsole(false).log("SRVLOG: " + par["txt"]);
	}

	isXtrViw() {
		return this.xtrViw;
	}

	isEtpPrt() {
		return this.isXtrViw() && ('EPT' === this.xtvTyp);
	}

	invoke(args) {
		args.__cbw = this;
		(this[args["invObj"]])[args["invMth"]](args);
	}

	invokeGlb(args) {
		args.__cbw = this;
		PSA.getInst()[args.invFnc](args);
	}

	setTtpAln(args) {
		const aln = args.aln || null;
		if ( aln ) {
			const tooltip = rwt.widgets.base.WidgetToolTip.getInstance();
			tooltip.setTextAlign(aln);
		}
		const tmo = args.tmo || 0;
		if ( typeof tmo === 'number' ) {
			const cfg = rwt.widgets.util.ToolTipConfig;
			cfg._fieldConfig.appearDelay = tmo;
			cfg._rowConfig.appearDelay = tmo;
		}
	}

	callBack(args) {
		const cid = args["cid"];
		if ( cid ) {
			const par = {};
			par["cid"] = cid;
			if ( this.ready ) {
				this.nfyGlb("callBack", par, true);
			} else {
				if ( !this.pndCbk ) {
					this.pndCbk = new Array();
				}
				this.pndCbk.push(par);
			}
		}
	}

	iniWndAcvNfy(args) {
		const nam = 'wndAcv';
		if ( !this[nam] ) {
			this.addObj(nam, new WndAcv(this));
		}
	}

	nfyWndAcv(acv) {
		if ( this.ready ) {
			const par = {};
			par.acv = !!acv;
			this.nfyGlb("glbWndAct", par, true);
		}
	}

	focusWindow() {
		window.focus();
	}

	jsCrash(args) {
		throw new Error('JS Crash');
	}

	addCss(args) {
		const lnk = document.createElement('link');
		lnk.rel = 'stylesheet';
		lnk.href = args["href"];
		lnk.type = 'text/css';
		document.head.appendChild(lnk);
	}

	iniDragDrop() {
		const cmg = this.conMgr;
		if ( cmg ) {
			this.addObj('filDrp', new FileDropTarget(document.body, cmg));
		}
	}

	frcDspSizUpd() {
		const dsp = rwt.widgets.Display.getCurrent();
		if ( dsp && (typeof dsp._onResize === 'function') ) {
			dsp._onResize();
		}
		if ( this.ready ) {
			const par = {};
			par.width = window.innerWidth;
			par.height = window.innerHeight;
			this.nfyGlb('displaySize', par, true);
		}
	}

	bscSrvCtr(args) {
		const srvctr = !!args.srvctr;
		if ( this.bscMgr ) {
			this.bscMgr.setSrvCtr(srvctr);
		}
	}

	shwBlkScr(args) {
		if ( this.bscMgr ) {
			this.bscMgr.shwBlkScr(args);
		}
	}

	setBscRqu() {
		this.bscMgr.setBscRqu();
	}

	setSpcKeyHdl(args) {
		PSA.getInst().keyHdl.setSpcHdl(args.spc);
	}

	setStgVal(args) {
		PSA.getInst().setStorageVal(args.name, args.value);
	}

	getStgVal(name) {
		return PSA.getInst().getStorageVal(name);
	}

	setScrNfo(args) {
		if ( args && args.scn ) {
			this.scrNfo = args.scn;
		}
	}

	getScrNfo() {
		return this.scrNfo;
	}

	shwDskNfy(args) {
		if ( DskNfy.isDskNfyAvl() ) {
			const idn = args.idn;
			const self = this;
			this.dskNfy.showNfy(idn, args.ttl, args.txt, args.ico, function(id, nfy) {
				if ( nfy ) {
					nfy.close();
				}
				const par = {};
				par.idn = idn;
				par.clk = true;
				self.nfyGlb("dskNfy", par, true);
			});
		}
	}

	shwFloMsg(args) {
		if ( this.floMgr ) {
			this.floMgr.shwMsg(args);
		}
	}

	drwVieTglBtn(args) {
		if ( this.vieTgl ) {
			this.vieTgl.drwBtn(args);
		}
	}

	rmvVieTglBtn(args) {
		if ( this.vieTgl ) {
			this.vieTgl.rmvBtn(args);
		}
	}

	suspendAllViewTglBtn(args) {
		if ( this.vieTgl ) {
			this.vieTgl.suspendAllViewTglBtn(args);
		}
	}

	simVieTglClk(args) {
		if ( this.vieTgl ) {
			this.vieTgl.simClk(args);
		}
	}

	setTglBtn(args) {
		if ( this.vieTgl ) {
			this.vieTgl.setTglBtn(args);
		}
	}

	setWakeLock(args) {
		const set = !!args.wakeLock;
		const wl = PSA.getInst().getWakeLock();
		if ( set ) {
			wl.setWakeLock();
		} else {
			wl.releaseWakeLock();
		}
	}

	printWnd() {
		try {
			window.print();
		} finally {
			const par = {};
			this.nfyGlb('printDone', par, false);
		}
	}

	setFavIco(args) {
		const href = args.url || '';
		const ctt = args.ctt || 'image/x-icon';
		if ( Validator.isString(href) ) {
			setTimeout(() => {
				try {
					const head = document.head || document.getElementsByTagName('head')[0];
					const old_link = document.querySelector("link[rel*='icon']");
					if ( old_link ) {
						old_link.parentNode.removeChild(old_link);
					}
					const new_link = document.createElement('link');
					new_link.rel = 'shortcut icon';
					new_link.type = ctt;
					new_link.href = href;
					head.appendChild(new_link);
				}
				catch ( e ) {
					console.error(e);
				}
			}, 14);
		}
	}

	iniCusCss(args) {
		const crefs = args.crefs || [];
		if ( crefs.length > 0 ) {
			const head = document.head;
			crefs.forEach((css) => {
				if ( Validator.isString(css) ) {
					const link = document.createElement('link');
					link.rel = 'stylesheet';
					link.type = 'text/css';
					link.href = '' + css;
					head.appendChild(link);
				}
			});
		}
	}

	iniCusFnt(args) {
		const fonts = args.fonts || [];
		if ( fonts.length > 0 ) {
			const head = document.head;
			fonts.forEach((cfd) => {
				const css = cfd.css || '';
				const tms = cfd.tms || '';
				const ver = cfd.version || '';
				if ( Validator.isString(css) ) {
					const link = document.createElement('link');
					link.rel = 'stylesheet';
					link.type = 'text/css';
					let href = '' + css;
					let que = false;
					if ( tms.length > 0 ) {
						href += '?tms=' + tms;
						que = true;
					}
					if ( Validator.isString(ver) ) {
						href += (que ? '&' : '?') + 'version=' + ver;
					}
					link.href = href;
					head.appendChild(link);
				}
			});
		}
	}

	initLocale(args) {
		if ( args ) {
			PSA.getInst().localeInfo = args;
		}
	}

	cpyWdgTxt(args) {
		const idw = args.idw || '';
		if ( Validator.isString(idw) ) {
			let div = null;
			const wdg = rwt.remote.ObjectRegistry.getObject(idw);
			if ( wdg && wdg._element ) {
				div = wdg._element;
			}
			if ( !div ) {
				const obj = rap.getObject(idw);
				if ( obj ) {
					div = obj.$el.get(0);
				}
			}
			if ( div ) {
				const chl = div.getElementsByTagName('INPUT');
				if ( chl && (chl.length > 0) ) {
					const inp = chl[0];
					inp.focus();
					inp.select();
					document.execCommand('copy');
				}
			}
		}
	}

	cpyClpCfd(args) {
		const clp_data = args.data || '';
		if ( Validator.isString(clp_data) ) {
			PSA.getInst().cpyClpCfd(clp_data, args.ico || {}, args.par || {});
		}
	}

	dlgCleanupDlg(args) {
		const idw = args.idw || '';
		if ( Validator.isString(idw) ) {
			PSA.getInst().dlgCleanupDlg(this, idw, args.ico || {}, args.par || {});
		}
	}

	rquTextSize(args) {
		const id = args.id || 0;
		const text = args.text || '';
		const font = args.font || null;
		const im = this.itmMgr;
		let txs = { cx: 0, cy: 0 };
		if ( Validator.isString(text) ) {
			const span = document.createElement('span');
			im.setFnt(span, font);
			span.innerText = text;
			txs = im.measureText(span, false, 0, false).sts;
		}
		const par = { id: id, resp: 'textSize', txs: txs };
		this.nfySrv(null, 'cbwResponse', par, false);
	}

	addRdrRqu(args) {
		const idw = args.idw || '';
		const rqu = args.rqu || '';
		const par = args.par || {};
		if ( Validator.isString(idw) && Validator.isString(rqu) ) {
			const name = `r-${++this.rrqCount}-${idw}-${rqu}`;
			const rdr = new RdrRqu(name, idw, rqu, par);
			const self = this;
			this.requestHolder.addRequest(name, () => {
				self._hdlRdrRqu(rdr);
			});
		}
	}

	setPlcTxt(args) {
		const idw = args.idw || '';
		const plc = args.plc || '';
		if ( Validator.isString(idw) && Validator.isString(plc) ) {
			const self = this;
			const cbk = () => {
				self.itmMgr.setPlcTxt(args);
			};
			const par = { idw: idw, cbk: cbk };
			const rqu = { idw: idw, rqu: 'cbkFnc', par: par };
			this.addRdrRqu(rqu);
		}
	}

	setWdgBorder(args) {
		const idw = args.idw || '';
		const style = args.style || '';
		const width = args.width || 0;
		const color = args.color || null;
		if ( Validator.isString(idw) ) {
			const self = this;
			const cbk = () => {
				self.itmMgr.setWdgBorder(idw, style, width, color);
			};
			const par = { idw: idw, cbk: cbk };
			const rqu = { idw: idw, rqu: 'cbkFnc', par: par };
			this.addRdrRqu(rqu);
		}
	}

	hackSash(args) {
		const idw = args.idw || '';
		if ( Validator.isString(idw) ) {
			const self = this;
			const cbk = () => {
				self.itmMgr.hackSash(idw, args);
			}
			const par = { cbk: cbk };
			const rqu = { idw: idw, rqu: 'cbkFnc', par: par };
			this.addRdrRqu(rqu);
		}
	}

	hackSashForm(args) {
		const idw = args.idw || '';
		if ( Validator.isString(idw) ) {
			const self = this;
			const cbk = () => {
				self.itmMgr.hackSashForm(idw, args);
			}
			const par = { cbk: cbk };
			const rqu = { idw: idw, rqu: 'cbkFnc', par: par };
			this.addRdrRqu(rqu);
		}
	}

	setRapMnuClr(args) {
		const idw = args.idw || '';
		if ( Validator.isString(idw) ) {
			const self = this;
			const cbk = () => {
				self.itmMgr.setRapMnuClr(args);
			}
			const par = { cbk: cbk };
			const rqu = { idw: idw, rqu: 'cbkFnc', par: par };
			this.addRdrRqu(rqu);
		}
	}

	updBtnLayout(args) {
		const idw = args.idw || '';
		const ics = args.ics || 0;
		if ( Validator.isString(idw) && (ics > 0) ) {
			const self = this;
			const cbk = () => {
				self.itmMgr.updBtnLayout(idw, ics);
			};
			const par = { cbk: cbk };
			const rqu = { idw: idw, rqu: 'cbkFnc', par: par };
			this.addRdrRqu(rqu);
		}
	}

	updSsnVerification(args) {
		this._stopSsnVerification();
		this._initSsnVerification(args);
	}

	_hdlRdrRqu(rqu) {
		const idw = rqu.idw;
		const wdg = rwt.remote.ObjectRegistry.getObject(idw);
		if ( wdg ) {
			switch ( rqu.rqu ) {
			case 'setID':
				this._setElmID(wdg, idw, rqu.par);
				break;
			case 'domFocus':
				this._setDomFocus(wdg, rqu.par);
				break;
			case 'qfnWdg':
				this.bscMgr.setQfnWdg(wdg);
				break;
			case 'cssClass':
				this.itmMgr.setCssCls(rqu.par);
				break;
			case 'styleProp':
				this._setStyleProp(wdg, rqu.par);
				break;
			case 'btnStatus':
				this.itmMgr.setBtnStatus(rqu.par);
				break;
			case 'cbkFnc':
				const par = rqu.par || {};
				if ( typeof par.cbk === 'function' ) {
					par.cbk();
				}
				break;
			default:
				break;
			}
		}
	}

	_setElmID(wdg, idw, par) {
		if ( wdg && wdg._element ) {
			const elm = wdg._element;
			if ( elm instanceof HTMLElement ) {
				const pfx = par.pfx || '_psa_';
				const ids = pfx + idw;
				elm.id = ids;
				const testId = pfx.split("-").filter(n => n).join("-");
				elm.dataset.testid = testId;
			}
		}
	}

	_setDomFocus(wdg, par) {
		if ( wdg && wdg._element ) {
			const main = wdg._element;
			let elm = main;
			if ( !!par.deep ) {
				while ( elm.firstElementChild ) {
					elm = elm.firstElementChild;
				}
			}
			elm.focus();
			elm.click();
			if ( !!par.auto ) {
				main.setAttribute('autofocus', '');
			}
		}
	}

	_setStyleProp(wdg, par) {
		if ( wdg && wdg._element && par && Validator.isString(par.style) && par.value ) {
			const im = ItmMgr.getInst();
			const css = wdg._element.style;
			const name = par.style;
			let value = par.value;
			if ( name.includes('color') ) {
				value = im.getRgb(value);
			} else if ( name.includes('font') ) {
				value = im.getFontCss(value);
			}
			css[name] = value;
		}
	}

	_sndTmz() {
		const now = new Date();
		const jan = new Date(now.getFullYear(), 0, 1, 12, 0, 0);
		const jul = new Date(now.getFullYear(), 6, 1, 12, 0, 0);
		const ofs = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset()) * 60000 * (-1);
		const par = {};
		par["tmz"] = ofs;
		const tzn = jstz.determine();
		if ( tzn ) {
			par["tzn"] = tzn.name();
		}
		par["iso"] = now.toISOString();
		par["loc"] = now.toLocaleString();
		par["sys"] = now.toString();
		this.nfyGlb("locTmz", par, false);
	}

	_sndStg() {
		const psa = PSA.getInst();
		const par = {};
		const prop = {};
		try {
			const stg = window.localStorage;
			if ( stg ) {
				Utils.forEachProp(stg, function(n, p) {
					prop[n] = p;
				});
			}
		} catch ( err ) {
			/* *gulp* */
		}
		par.stg = prop;
		par.oldIE = psa.Info.isOldIE();
		par.brwOk = !!psa.brwOk;
		par.verJsc = psa.Info.getWebClientVersion();
		par.verBti = psa.Info.getBuiltInVersion();
		par.verCKE5 = PisaCKEditor.getInstance().version || '';
		par.usrUrl = top.location.href || '';
		const wl = psa.getWakeLock();
		par.wakeLock = wl ? !!wl.supported : false;
		this.nfyGlb("cliStg", par, false);
	}

	_blur(evt) {
		this.focusHistory.push(evt.target);
		while ( this.focusHistory.length > 5 ) {
			this.focusHistory.shift();
		}
	}

	_onWndPos() {
		const psa = PSA.getInst();
		if ( this.isXtrViw() && Validator.isString(this.xtvTyp) ) {
			const x = window.screenLeft || window.screenX;
			const y = window.screenTop || window.screenY;
			const wrc = psa.creJsRect(x, y, window.outerWidth, window.outerHeight);
			const val = JSON.stringify(wrc);
			const key = this.xtvTyp + '_wndpos';
			this.setStgVal({name: key, value: val});
		}
	}

	_click(evt) {
		this.focusHistory.push(evt.target);
		while ( this.focusHistory.length > 5 ) {
			this.focusHistory.shift();
		}
	}

	_initSsnVerification(args) {
		const uuid = args.uuid || '$NONE';
		const self = this;
		self._vfyCount = 0;
		const f = () => {
			++self._vfyCount;
			const par = { uuid: uuid, count: self._vfyCount };
			self.nfyGlb('ssnVerification', par, null);
		}
		this._onSend = f;
		rap.on('send', f);
	}

	_stopSsnVerification() {
		if ( this._onSend ) {
			rap.off('send', this._onSend);
			delete this._onSend;
		}
	}

	static register() {
		rap.registerTypeHandler("pisasales.CliCbkWdg", {
			factory: function(properties) {
				return new CliCbkWdg(properties);
			},
			destructor: "destroy",
			properties: ['xtrVieTyp'],
			methods: [ "logTxt", "invoke", "invokeGlb", "setTtpAln", "callBack", "iniWndAcvNfy", "focusWindow", "jsCrash", "addCss",
					"iniDragDrop", "frcDspSizUpd", "bscSrvCtr", "shwBlkScr", "setStgVal", "setSpcKeyHdl", "setScrNfo",
					"shwDskNfy", "shwFloMsg", "drwVieTglBtn", "rmvVieTglBtn", "suspendAllViewTglBtn", "simVieTglClk", "setTglBtn", "setWakeLock", "printWnd", "addRdrRqu",
					"setPlcTxt", "setRapMnuClr", "setFavIco", "iniCusCss", "iniCusFnt", "initLocale", "cpyWdgTxt", "cpyClpCfd", "dlgCleanupDlg",
					"rquTextSize", "setWdgBorder", "hackSash", "hackSashForm", "updBtnLayout", "updSsnVerification" ],
			events: [ "PSA_NFY_SRV", "PSA_NFY_NBS", "PSA_NFY_ERR" ]
		});
	}
}
